import jQuery from "jquery";
import React, { useEffect, useRef, useState } from "react";
import useFetchData from "../../../common/api/useFetchData";
import { ConditionalWrapper } from "../../../common/components/ConditionalWrapper";
import { useMutationObserver } from "../../../common/useMutationObserver";
import clsx from "clsx";

interface AdProps {
	heading?: string;
	code?: string;
	sticky?: boolean;
}

export function Ad({ heading, code, sticky = false }: AdProps) {
	const { data } = useFetchData({ endpoint: `/api/v1/slots/${code}` });
	const [adHidden, setAdHidden] = useState(false);
	const mutationRef = useRef<HTMLInputElement>(null);

	// If ad is configured in admin area but still does not show up
	const handleFetchedAd = () => {
		setAdHidden(
			mutationRef.current?.querySelector('div[id^="placement_"]')
				?.children.length === 0,
		);
	};
	useMutationObserver(mutationRef, handleFetchedAd);

	// Remove line breaks and double quotation marks
	const content = data?.html
		?.replace(/\r?\n|\r/g, "")
		.replace(/"/g, "")
		.trim();

	useEffect(() => {
		if (content) {
			// jQuery is here to insert and execute <script> from ad third-party
			const $contentContainer = jQuery(`#ad_wrapper_${code}`);
			$contentContainer.html(content);
		}
	}, [content]);

	if (!data || data?.error) {
		return null;
	}

	return (
		<ConditionalWrapper
			condition={!!heading}
			wrapper={(children) => (
				<div className={clsx("ad-wrapper", { hidden: adHidden })}>
					<p>{heading}</p>
					{children}
				</div>
			)}
		>
			<div
				className={clsx("ad", { sticky })}
				id={`ad_wrapper_${code}`}
				ref={mutationRef}
			></div>
		</ConditionalWrapper>
	);
}
